import { PackageType } from '__generated__/api';
import { PackageType as PackageTypeDomain } from 'models/multi-item/multi-item-types';

type PackageMap = Record<PackageTypeDomain, PackageType>;

export const packageTypeMap: PackageMap = {
  FH: PackageType.FLIGHT_HOTEL,
  HC: PackageType.HOTEL_CAR,
  FHC: PackageType.FLIGHT_HOTEL_CAR,
  FC: PackageType.FLIGHT_CAR
};
